<template>
  <fixed-bar class="header-menu">
    <div class="header-menu__brand">
      <icon :icon="iconName" :height="iconHeight" :width="iconWidth" />
      <span class="header-menu__divider" aria-hidden="true"></span>
      <span class="text">Car Sales Tool</span>
    </div>
    <div class="align-right">
      <brand-selector />
      <establishment-selector />
    </div>
  </fixed-bar>
</template>

<script>
import FixedBar from '@/components/generic/presentational/atoms/fixedBar/FixedBar.vue'
import BrandSelector from '@/components/generic/presentational/molecules/brandSelector/BrandSelector.vue'
import EstablishmentSelector from '@/components/generic/presentational/molecules/establishmentSelector/EstablishmentSelector.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import { getBrandName, brands } from '@/helpers/BrandHelper'

export default {
  components: {
    FixedBar,
    BrandSelector,
    EstablishmentSelector,
    Icon,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    iconName() {
      return `logo-brand-${getBrandName()}`
    },
    iconWidth() {
      if (getBrandName() === brands.Cupra) return 200
      if (getBrandName() === brands.Volkswagen) return 32
      if (getBrandName() === brands.VwBedrijfswagens) return 110
      return 100
    },
    iconHeight() {
      if (getBrandName() === brands.Cupra) return 40
      if (getBrandName() === brands.Seat) return 30
      if (getBrandName() === brands.Volkswagen) return 32
      return 24
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.header-menu {
  background: $white;
  box-shadow:
    inset 0 -1px 0 var(--color-border),
    0 2px 14px rgba(0, 0, 0, 0.05);
}

.header-menu :deep(.container) {
  max-width: none;
  margin: 0;
  padding: 0 24px 0 68px;
  height: 72px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-menu__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  flex: none;
}

.header-menu__divider {
  width: 1px;
  height: 26px;
  background: var(--color-border);
  flex: none;
}

.text {
  font-size: 1rem;
  font-weight: 600;
  color: var(--header-title-color);
  letter-spacing: -0.01em;
  white-space: nowrap;
}

.align-right {
  margin-left: auto;
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
}
</style>
